/** @jsxImportSource theme-ui */

import {
  Box,
  Button,
  Flex,
  Grid,
  Heading,
  IconButton,
  Link,
  Text,
} from "theme-ui";
import Me from "./Me";
import { ReactComponent as Linkedin } from "../../assets/linkedin.svg";
import { ReactComponent as Mail } from "../../assets/mail.svg";
import { ReactComponent as Resume } from "../../assets/resume.svg";
import { LINKS } from "../../utils/constants";
import { about } from "./content";

export default function Hero() {
  return (
    <Grid
      sx={{
        p: ["50px 0 50px", null, "161px 0 53px"],
        gridTemplateColumns: ["auto auto", null, "auto 1fr"],
        gridTemplateRows: "auto 1fr",
        gap: ["30px", null, "37px 60px", "37px 169px"],
        display: ["flex", "grid"],
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Me
        sx={{
          gridColumnStart: 1,
          gridColumnEnd: 2,
          gridRowStart: [2, null, 1],
          gridRowEnd: [3, null, 2],
          p: [null, "0 0 3px 6px"],
          zIndex: 2,
          alignSelf: [null, "flex-end"],
        }}
      />
      <Box
        className="fadein"
        data-delay="0.1"
        sx={{
          gridRowStart: [2, null, 1],
          gridRowEnd: [3, null, 2],
          gridColumnStart: 1,
          gridColumnEnd: 3,
          backgroundColor: "#F7F7F7",
          borderRadius: "20px",
          display: ["none", "block"],
          width: "100%",
          height: "100%",
        }}
      />
      <Flex
        sx={{
          gridRowStart: [2, null, 1],
          gridRowEnd: [3, null, 2],
          gridColumnStart: 2,
          gridColumnEnd: 3,
          flexDirection: "column",
          justifyContent: ["center", null, "flex-start"],
          gap: ["15px", "18px"],
          pt: ["0", null, "40px"],
          pb: ["30px", null, "50px"],
          pr: [0, "30px"],
          zIndex: 1,
          span: {
            fontSize: [2, null, null, 3], // Keep responsive sizing for spans
            fontWeight: "bold",
            lineHeight: "166%",
          },
        }}
      >
        <Heading
          as="strong"
          className="fadein"
          data-delay="0.2"
          variant="h1"
          sx={{ mb: ["15px", "36px"], mt: ["8px", "8px"] }}
        >
          About Me
        </Heading>
        <Text
          className="fadein"
          data-delay="0.2"
          dangerouslySetInnerHTML={{ __html: about[0] }}
          sx={{ maxWidth: [null, "910px"] }}
        />
        <Text
          className="fadein"
          data-delay="0.3"
          dangerouslySetInnerHTML={{ __html: about[1] }}
          sx={{ maxWidth: [null, "910px"] }}
        />
        <Text
          className="fadein"
          data-delay="0.4"
          dangerouslySetInnerHTML={{ __html: about[2] }}
          sx={{ maxWidth: [null, "910px"] }}
        />
        <Flex
          sx={{
            gap: "9px",
            alignItems: "center",
            mt: "auto",
            justifyContent: "flex-start",
            pt: ["20px", "30px"],
          }}
        >
          <IconButton
            as={Link}
            href={LINKS.LINKEDIN}
            target="__blank"
            className="fadein"
            data-delay="0.6"
          >
            <Linkedin />
          </IconButton>
          <IconButton
            variant="iconStroke"
            as={Link}
            href={LINKS.EMAIL}
            className="fadein"
            data-delay="0.7"
          >
            <Mail />
          </IconButton>
          <Box
            sx={{
              ml: "11px",
            }}
            className="fadein"
            data-delay="0.9"
          >
            <Button
              as={Link}
              href={LINKS.RESUME}
              target="_blank"
              sx={{
                lineHeight: "160%",
                minWidth: "150px",
                svg: {
                  mr: "7px",
                  width: "14px",
                  height: "auto",
                },
              }}
            >
              <Resume /> Resume
            </Button>
          </Box>
        </Flex>
      </Flex>
    </Grid>
  );
}
